import { type AddHookResponse, mutationAdd } from '../../hooks'
import { useTantalimMutation } from '../../mutation'
import { useGameCache } from '../cache'
import { type GameParticipantAddInput, type GameParticipantAddSuccess, toResponseError } from '@terros/common'

export function useAddGameParticipant(): AddHookResponse<GameParticipantAddInput, GameParticipantAddSuccess> {
  const cache = useGameCache()

  const mutation = useTantalimMutation<GameParticipantAddInput, GameParticipantAddSuccess>({
    url: '/game/participant/add',
  })

  async function add(input: GameParticipantAddInput): Promise<GameParticipantAddSuccess> {
    try {
      const output = await mutation.mutateAsync(input)
      cache.clearItem(input.gameId)
      return output
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
